export const API_PATHS = {
  AUTH: {
    ME: '/api/auth/me',
    LOGOUT: '/api/auth/logout',
    GOOGLE: '/api/auth/google',
    REFRESH: '/api/auth/refresh',
  },
  FLOWS: {
    BASE: '/api/flows',
    BY_ID: (id: string) => `/api/flows/${id}`,
    SYNC_BY_ID: (id: string) => `/api/flows/${id}/sync`,
    CLONE_BY_ID: (id: string) => `/api/flows/${id}/clone`,
  },
  MESSAGES: {
    BASE: '/api/messages',
    BY_ID: (id: string) => `/api/messages/${id}`,
    CLOSE: (id: string) => `/api/messages/${id}/close`,
    MEDIA: (id: string) => `/api/messages/${id}/media`,
  },
  CONVERSATIONS: {
    BASE: '/api/conversations',
    THREAD: (phone: string) => `/api/conversations/${phone}/thread`,
  },
} as const
